import React from 'react';
import { 
  Sparkles, 
  CheckCircle2, 
  Smile, 
  Palette, 
  Timer,
  Ruler,
  Heart,
  Lightbulb
} from 'lucide-react';
import './Dto43c.css';

const Dto43c: React.FC = () => {
  return (
    <div className="dto43c">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Ceramic Veneers</h1>
          <p>Transform Your Smile with Custom All-Ceramic Veneers</p>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="intro-section container">
        <div className="intro-content">
          <div className="intro-text">
            <h2>What are Ceramic Veneers?</h2>
            <p>
              All-ceramic veneers are ultra-thin, custom-made shells designed to 
              cover the front surface of teeth. Using advanced technology, we can 
              quickly improve dental imperfections and permanently enhance both the 
              shape and color of your teeth, creating your perfect smile.
            </p>
          </div>
          <div className="intro-image">
            <img 
              src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&q=80&w=1500"
              alt="Dental Veneers"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Perfect for Your Smile</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <CheckCircle2 className="benefit-icon" />
              <h3>Repair Damage</h3>
              <p>Fix cavities, chipped corners, and fractures of front teeth</p>
            </div>
            <div className="benefit-card">
              <Palette className="benefit-icon" />
              <h3>Color Correction</h3>
              <p>Address tooth staining and discoloration effectively</p>
            </div>
            <div className="benefit-card">
              <Ruler className="benefit-icon" />
              <h3>Size Adjustment</h3>
              <p>Perfect solution for undersized teeth and gap corrections</p>
            </div>
            <div className="benefit-card">
              <Smile className="benefit-icon" />
              <h3>Shape Enhancement</h3>
              <p>Improve unsatisfactory tooth shapes for a perfect smile</p>
            </div>
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="cases-section container">
        <h2 className="section-title">Success Stories</h2>
        
        <div className="case-study">
          <h3>Case 1: Smile Curve Design</h3>
          <div className="case-content">
            <div className="case-text">
              <p>
                Patient with history of tooth decay and uneven coloring from multiple 
                fillings achieved a natural, crystal-clear result through our Realistic 
                Ultra-Thin Veneer treatment.
              </p>
              <ul className="case-features">
                <li>
                  <Sparkles className="feature-icon" />
                  <span>Natural tooth preservation</span>
                </li>
                <li>
                  <Heart className="feature-icon" />
                  <span>Crystal clear finish</span>
                </li>
                <li>
                  <Timer className="feature-icon" />
                  <span>Quick improvement</span>
                </li>
              </ul>
            </div>
            <div className="case-image">
              <img 
                src="https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?auto=format&fit=crop&q=80&w=1500"
                alt="Smile Transformation"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="case-study">
          <h3>Case 2: Professional Aesthetic Restoration</h3>
          <div className="case-content">
            <div className="case-text">
              <p>
                A professional requiring camera-ready confidence achieved perfect 
                proportions and natural color gradients through our advanced 
                custom-made veneer technique.
              </p>
              <ul className="case-features">
                <li>
                  <Palette className="feature-icon" />
                  <span>Natural color gradient</span>
                </li>
                <li>
                  <Ruler className="feature-icon" />
                  <span>Perfect proportions</span>
                </li>
                <li>
                  <Smile className="feature-icon" />
                  <span>Enhanced confidence</span>
                </li>
              </ul>
            </div>
            <div className="case-image">
              <img 
                src="https://images.unsplash.com/photo-1616628188859-7a11abb6fcc9?auto=format&fit=crop&q=80&w=1500"
                alt="Professional Transformation"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Treatment Considerations */}
      <section className="considerations-section">
        <div className="container">
          <h2 className="section-title">Treatment Planning</h2>
          <div className="considerations-grid">
            <div className="consideration-card">
              <Lightbulb className="consideration-icon" />
              <h3>Combined Treatment Options</h3>
              <div className="treatment-scenarios">
                <div className="scenario">
                  <h4>Scenario 1</h4>
                  <p>
                    Patients with abnormal bite or protruding teeth may benefit from 
                    combined orthodontic treatment.
                  </p>
                </div>
                <div className="scenario">
                  <h4>Scenario 2</h4>
                  <p>
                    Deep bite, open bite cases are recommended to combine orthodontic 
                    treatment for optimal functional and aesthetic results.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section container">
        <div className="cta-content">
          <h2>Transform Your Smile Today</h2>
          <p>
            Your perfect smile is just a consultation away. Our expert team will 
            create a customized treatment plan tailored to your specific needs.
          </p>
          <div className="cta-image">
            <img 
              src="https://images.unsplash.com/photo-1513757271804-385fb022e70f?auto=format&fit=crop&q=80&w=1500"
              alt="Beautiful Smile"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dto43c;